import React from 'react';
import Typography from '@material-ui/core/Typography';
import { Grid } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import GraficaOXI from './grafiaOXI';
import Tooltip from '@material-ui/core/Tooltip';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';

const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: '#f5f5f9',
        color: 'rgba(0, 0, 0, 0.87)',
        maxWidth: 220,
        fontSize: theme.typography.pxToRem(15),
        border: '1px solid #dadde9',
    },
}))(Tooltip);


export default function ChartOximetria({ data, dataD, fechaIni, fechaFin, valorTotal }) {
    const series = [
        dataD[0]?.value1 === undefined ? 0 : dataD[0].value1,
        dataD[1]?.value2 === undefined ? 0 : dataD[1].value2,
        dataD[2]?.value3 === undefined ? 0 : dataD[2].value3,
        dataD[3]?.value4 === undefined ? 0 : dataD[3].value4,
    ];

    return (
        <>
            <Grid container spacing={2} alignItems="center" justifyContent="center">
                <Grid item>
                    <Grid item xs={12} sm container>
                        <Grid item xs container>
                            <Grid item xs>
                                <Grid item xs={12} sm container alignItems="center">
                                    <Grid item xs={12} sm container alignItems="center">
                                        <Typography align="center" alignItems="center" style={{ fontWeight: 'bold', fontSize: "30px" }}color='primary'>
                                            Valores de Oximetría
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

            <Grid container spacing={2} alignItems="start" justifyContent="center" style={{ marginTop: '0%', marginLeft: "5%", width: '100%', height: '150px' }}>
                <Grid item>
                    <Grid item xs={3} sm container>
                        <Grid item xs container direction="column">
                            <Grid item xs={12} md={12} lg={12}>
                                <GraficaOXI series={series} />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={3} style={{ marginLeft: '65%', marginTop: '-19.5%', zIndex: 500 }}>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <div style={{ marginBottom: '10px' }}>
                            <div style={{ height: '22px' }}>
                                <HtmlTooltip
                                    title={
                                        <React.Fragment>
                                            <Typography>Descripción</Typography>
                                            <b><br />{"NORMAL:"}</b>{' '}
                                            {"Mediciones de oximetría mayores a 95%."}
                                        </React.Fragment>
                                    }
                                    placement="right-start"
                                >
                                    <HelpOutlineIcon style={{ height: '21px' }}color='primary'/>
                                </HtmlTooltip>
                            </div>


                            <div style={{ height: '22px' }}>
                                <HtmlTooltip
                                    title={
                                        <React.Fragment>
                                            <Typography>Descripción</Typography>
                                            <b><br />{"HIPOXIA LEVE:"}</b>{' '}
                                            {"Mediciones de oximetría entre 95% y 91%."}
                                        </React.Fragment>
                                    }
                                    placement="right-start"
                                >
                                    <HelpOutlineIcon style={{height: '21px' }} color='primary' />
                                </HtmlTooltip>
                            </div>


                            <div style={{ height: '22px' }}>
                                <HtmlTooltip
                                    title={
                                        <React.Fragment>
                                            <Typography>Descripción</Typography>
                                            <b><br />{"HIPOXIA MODERADA:"}</b>{' '}
                                            {"Mediciones de oximetría menores a 90%."}
                                        </React.Fragment>
                                    }
                                    placement="right-start"
                                >
                                    <HelpOutlineIcon style={{height: '21px' }} color='primary' />
                                </HtmlTooltip>
                            </div>


                            <div style={{ height: '22px' }}>
                                <HtmlTooltip
                                    title={
                                        <React.Fragment>
                                            <Typography>Descripción</Typography>
                                            <b><br />{"SIN REGISTRO"}</b>{' '}
                                            {"Usuarios que no se han realizado las mediciones de oximetría en la estación de tele salud."}
                                        </React.Fragment>
                                    }
                                    placement="right-start"
                                >
                                    <HelpOutlineIcon style={{ height: '21px' }}color='primary' />
                                </HtmlTooltip>
                            </div>
                        </div>
                    </div>

                </Grid>
            </Grid>
        </>
    );
}
